// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"490ddfc1","615":"ac32dbd4"}[chunkId] + ".chunk.css";
};